"use client";

import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";

let sentryInitialized = false;

export default function SentryInit() {
  useEffect(() => {
    if (sentryInitialized) {
      return;
    }

    Sentry.init({
      dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
      enabled: Boolean(process.env.NEXT_PUBLIC_SENTRY_DSN),
      environment: process.env.NODE_ENV,
      release: process.env.NEXT_PUBLIC_SENTRY_RELEASE,
      tracesSampleRate: 0.1,
    });

    sentryInitialized = true;
  }, []);

  return null;
}
